import axios from "axios";
import { API_HOST } from "@/core/variables";
import { TypoCreate, TypoUpdate } from "@/model";

class TypoRepository {
    find = async (
        agentId: number,
        page: number,
        size: number,
        order: 'asc' | 'desc',
        keyword?: string
    ) => {
        return axios
            .get(`${API_HOST}/v1/agents/${agentId}/typos`, {
                params: {
                    agent_id: agentId,
                    page: page,
                    size: size,
                    order: order,
                    keyword: keyword
                }
            })
            .then((response) => Promise.resolve(response))
            .catch((error) => Promise.reject(error));
    };
    
    create = async (agentId: number, form: TypoCreate) => {
        return axios
            .post(`${API_HOST}/v1/agents/${agentId}/typos`, {
                ...form
            })
            .then((response) => Promise.resolve(response))
            .catch((error) => Promise.reject(error));
    };
    
    update = async (agentId: number, typoId: string, form: TypoUpdate) => {
        return axios
            .put(`${API_HOST}/v1/agents/${agentId}/typos/${typoId}`, {
                ...form
            })
            .then((response) => Promise.resolve(response))
            .catch((error) => Promise.reject(error));
    };

    deleteMany = async (agentId: number, ids?: string[], keyword?: string) => {
        const params = new URLSearchParams();
        ids?.forEach((id) => {
            params.append("ids", id);
        });
        if (keyword) {
            params.append("keyword", keyword);
        }
        return axios
            .delete(`${API_HOST}/v1/agents/${agentId}/typos`, {
                params: params
            })
            .then((response) => Promise.resolve(response))
            .catch((error) => Promise.reject(error));
    };

    import = async (agentId: number, file: File, isCleanImport?: boolean) => {
        const form = new FormData();
        const is_clean_import = isCleanImport ? '1' : '0';
        form.append("is_clean_import", is_clean_import);
        form.append("file", file);

        return axios
            .post(`${API_HOST}/v1/agents/${agentId}/typos/import`, form)
            .then((response) => Promise.resolve(response))
            .catch((error) => Promise.reject(error));
    };

    export = (agentId: number, params?: {ids?: string[], keyword?: string}) => {
        const urlParams = new URLSearchParams();
        params?.ids?.forEach(id => urlParams.append("ids", id));
        if (params?.keyword) {
            urlParams.append("keyword", params.keyword);
        }
        window.open(`${API_HOST}/v1/agents/${agentId}/typos/export?${urlParams}`);
    };
}

const typoRepository = new TypoRepository();

export default typoRepository;
